const faqData = {
  ja: [
    {
      id: 1000,
      title: '初回ログイン',
      content: [
        {
          id: 1001,
          title: 'マニュアルはありますか？',
          html: `<p>&wellアプリログインマニュアル</p>
          <p><a href="/files/2024/download_and_login.pdf" target="_blank">ダウンロード・ログインマニュアル</a></p>`,
        },
        {
          id: 1002,
          title: '&wellアプリはどこからダウンロードできますか？',
          html: `
          <p>ご利用の端末から、以下のQRをQRリーダーで撮影するとストアへ遷移します。または、URLから遷移してください。</p>
          <div class="col2 mt-30">
            <div style="margin-right:30px;">
              <b>iPhone(iOS)をご利用の方</b>
              <p>App Storeからのインストール</p>
              <p><a href="https://apps.apple.com/jp/app/well/id1434515379" target="_blank">LINK</a></p>
              <img src="img/faq/ios.png" width="160" alt="iPhone">
            </div>
            <div>
              <b>Androidをご利用の方</b>
              <p>Google Playからのインストール</p>
              <p><a href="https://play.google.com/store/apps/details?id=jp.andwell" target="_blank">LINK</a></p>
              <img src="img/faq/android.png" width="160" alt="android">
            </div>
          </div>
          <br>
          <p>※会社貸与の端末において、セキュリティ上の理由で任意でアプリのインストールができない場合がございます。<br>
          QRが読み取れないなど発生した場合、企業または健康保険組合の担当窓口へお問い合わせください。</p>`,
        },
        {
          id: 1003,
          title:
            '初回会員登録でアカウント・パスワードがわかりません。どうすればよいですか？',
          html: `
          <h3>アカウントがわからない方</h3>
          <p>初回のログインアカウントは、メールアドレスか英数字文字列のどちらかになります。所属企業または健康保険組合よりメール等で&wellの案内がありますのでご確認ください。不明な場合は、企業または健康保険組合の担当窓口へお問い合わせください。</p>

          <h3>パスワードがわからない方</h3>
          <p>
          アカウントがメールアドレスの方は、初期パスワードは不要です。<br>
          アカウントが英数字文字列の方は、企業または健康保険組合からの案内を確認してください。不明な場合は、企業または健康保険組合の担当窓口へお問い合わせください。
          </p>
          `,
        },
        {
          id: 1004,
          title:
            'ログインをしましたが、「&wellとは」の画面からホーム画面にいけません。どうすればよいですか？',
          html: `表示されている&well説明画面を何回か左にスワイプすると、最後に「あすけんと連携する」という画面が表示されます。
          その表示画面下の「次へ」のボタンを押下すると画面が遷移します。
          `,
        },
        {
          id: 1005,
          title:
            '&wellアプリの設定途中で、別のアプリ「ヘルスケア」（または、「Google Fit」）のダウンロードを求められますが、必ずしないといけないのでしょうか？',
          html: `
          <h3>iPhone（iOS）をご利用の方</h3>
          <p>「ヘルスケア」アプリは、iPhone（iOS）に標準インストールされているアプリです。インストールの必要はありません。</p>

          <h3>Androidをご利用の方</h3>
          <p>「Google Fit」アプリのダウンロードが必要です。Google アカウントでログインする必要があります。<br>
          ※「Google Fit」のご利用には、「Google Fit」および「&wellアプリ」を、「ヘルスコネクト」アプリと連携する必要があります</p>
          `,
        },
        {
          id: 1006,
          title: '&wellアプリ、&well会員サイトは、共通のアカウント・パスワードでしょうか？',
          html: `はい、共通のアカウント・パスワードです。
          `,
        },
        {
          id: 1007,
          title: '&wellアプリのみの利用は可能でしょうか？',
          html: `はい、可能です。
          `,
        },
        {
          id: 1008,
          title: '&well会員サイトのみの利用は可能でしょうか？',
          html: `
          はい、可能です。動画やLIVE配信、読み物系コンテンツを中心にお楽しみいただけます。<br>
          但し、Webサイトで歩数や自分ログの入力、ミッションの達成等はできません。また、アプリを立ち上げない場合は歩数の取得ができません。
          `,
        },
        {
          id: 1009,
          title: '言語設定は何がありますか？変更方法を教えてください。',
          html: `
          <p>
          日本語と英語（自動翻訳）があります。<br>
          変更方法は、以下をご覧ください。
          </p>

          <h3>アプリで変更する場合</h3>
          <p>ホーム画面の右上の歯車マークを押下＞マイページの言語設定language ＞ 日本語/英語を選択 ＞ OKを押下</p>

          <h3>Webサイトで変更する場合</h3>
          <p>ログイン後トップページの右上のアイコンを押す＞マイページの言語設定language ＞ 日本語/英語を押下 ＞ ×部分を押下し閉じる</p>
          `,
        },
      ],
    },
    {
      id: 2000,
      title: 'アカウント・パスワード・登録アドレス',
      content: [
        {
          id: 2001,
          title: 'アカウント・パスワードを忘れてしまいました。',
          html: `
          <h3>アカウントを忘れた方</h3>
          <p>ログインアカウントは、メールアドレスか英数字文字列のどちらかになります。不明な場合は、所属企業の人事部（総務部）、または所属の健康保険組合の担当窓口へお問い合わせください。
          問い合わせ先がわからない場合、&well事務局へお問い合わせください。</p>

          <h3>パスワードを忘れた方</h3>
          <p><a href="https://go.andwell.jp/resetPassword">パスワードのリセット・変更はこちら</a></p>
          `,
        },
        {
          id: 2002,
          title: '登録したメールアドレスを変更したいです。',
          html: `
          <p>
          アカウントがメールアドレスの場合、変更はできません。<br>
          アカウントが英数字文字列の場合は、登録アドレスの変更ができます。<br>
          </p>
          <p>＜変更手順＞
          ホーム画面の右上の歯車マークを押下＞マイページの「メールアドレスを確認する」＞メールアドレス欄に変更したいメールアドレスを入力＞「変更する」を押下
          </p>
          <p>
          アカウントがどちらのタイプかは、所属の企業、健康保険組合ごとに決められています。
          </p>
          `,
        },
        {
          id: 2003,
          title: '&wellアプリ、&well会員サイトは、共通のパスワードですか？',
          html: `はい、共通のパスワードです。`,
        },
        {
          id: 2004,
          title: '退会したいです。',
          html: `&well退会のご希望につきましては、貴社&wellご担当者様へご連絡ください。`,
        },
      ],
    },
    {
      id: 3000,
      title: '利用端末・ウェアラブル端末',
      content: [
        {
          id: 3001,
          title: 'ログインしていますが、歩数が連携できません。（iPhone：iOSにおけるヘルスケアとの連携方法）',
          html: `
          <p>以下の手順でご確認ください。</p>
          <p class="mt-20">＜手順＞</p>
          <ol>
          <li>&wellアプリの確認
          <li>iPhone端末の確認
          </ol>

          <p class="mt-20">＜手順詳細＞</p>
          <h3>1. &wellアプリの確認方法</h3>
          <p>ホーム画面の右上の歯車マークを押下＞マイページよりデータ連携を確認。連携している外部アプリが「ヘルスケア」と記載がされていることを確認してください。</p>
          <p>「ヘルスケア」の表記がない場合、連携している外部アプリを押下すると、選択画面が表示されますので、「ヘルスケア」を選択してください。</p>

          <h3>2. iPhone端末の確認方法</h3>
          <p>（1）ヘルスケア自体に歩数がカウントされているか確認してください。</p>
          <p>※ヘルスケアが歩数をカウントしていない場合は、後述（2）記載の手順でデータ設定をお願いいたします。</p>

          <p>（2）ヘルスケアのデータ設定をご確認ください。</p>
          <p>iPhone端末の設定＞ヘルスケア＞データアクセスとデバイス＞&well＞右側のボタンが全てオン（緑色表示）になっていることを確認</p>

          <p>上記に問題ない場合、&wellアプリがフリーズしている可能性があります。以下の手順をお試しください。</p>

          <p>例）1.アプリを終了する。→連携されているか歩数を確認</p>

          <p>1.アプリを終了する。</p>
          <p>※終了する方法は、検索サイトで「お使いの携帯電話（iPhone）」と「アプリを終了させる方法」などと入力し検索すると確認できます。</p>

          <p>2.アプリからログアウトし、再ログインする。</p>

          <p>3.スマートフォンの電源を入れなおす。</p>

          <p>4.アプリをアンインストール → 再インストール</p>
          <p>※会社貸与の端末において、セキュリティ上の理由で任意でアプリのインストールができない場合がございます。QRコードが読み取れないなど発生した場合、企業の担当窓口へお問い合わせください。</p>

          <p>なお、外部アプリに手入力している歩数は&wellアプリの仕様上反映されませんのでお気をつけください。</p>

          <p>上記実施後も、歩数が連携されない場合、連携している外部アプリを解除し、再度ヘルスケアを設定後アプリを再起動してください。</p>
          <p>ホーム画面の右上の歯車マークを押下＞マイページ 連携している外部アプリを押下＞解除しますかのポップアップが出るので「はい」押下＞ヘルスケア選択＞連携している外部アプリが「ヘルスケア」と記載がされていることを確認＞アプリ再起動</p>
          `,
        },
        {
          id: 3002,
          title: 'ログインしていますが、歩数が連携できません。（AndroidにおけるGoogle Fitとの連携方法）',
          html: `
          <p>Google fitおよび&wellアプリが「ヘルスコネクト」アプリと連携しているか、ご確認いただけますでしょうか。</p>
          <br>
          <h3>■「ヘルスコネクト」アプリ連携確認方法</h3>
          <p>①②の手順をご確認ください。※OSのバージョン毎に異なります。</p>

          <h3>①-1：Android OS 14以上の場合</h3>
          <p>1.設定＞アプリ＞セキュリティとプライバシー：ヘルスコネクトをタップ</p>
          <p>2.ヘルスコネクト：アプリの権限をタップ</p>
          <p>3.アプリ権限：「Fit」をタップ</p>
          <p>4.アプリのアクセス権：全て許可にチェックが入っているか</p>
          <p>5.アプリの権限：アクセスが許可されているアプリに「Fit」が表示されるか</p>
          <p>上記は事前準備です。</p>
          <p>→その後、&wellの外部連携画面から&wellにヘルスコネクトへのアクセスを許可に関する表示が出るので、「すべてを許可」を選択して連携してください。</p>
          <p>＜権限確認＞</p>
          <p>6.ヘルスコネクトの設定画面にて「アプリの権限」をタップ</p>
          <p>7.アクセスが許可されているアプリに、fitと&wellが記載されているか確認</p>
          <p>→ 表示がない場合、アクセスが許可されていないアプリにfit、&wellが表示されているのでタップして許可してください</p>

          <h3>①-2：Android OS 9-13の場合</h3>
          <p>1.端末のアプリ一覧の画面で「ヘルスコネクト」を検索</p>
          <p>2.検索結果に「ヘルスコネクト」アプリが表示されるのでリンクをタップ</p>
          <p>3-a.ヘルスコネクトがインストールされていなければ「インストール」ボタンをタップ</p>
          <p>→ 「使ってみる」→「アプリの権限」からGoogle fitを追加する</p>
          <p>3-b.ヘルスコネクトがインストールされていれば「開く」をタップ</p>
          <p>→ ヘルスコネクトのアプリの権限にGoogle fitを追加する</p>
          <p>→その後、&wellの外部連携画面から&wellにヘルスコネクトへのアクセスを許可に関する表示が出るので、「すべてを許可」を選択して連携してください。</p>
          <p>＜権限確認＞</p>
          <p>4.ヘルスコネクトの設定画面にて「アプリの権限」をタップ</p>
          <p>5.アクセスが許可されているアプリに、fitと&wellが記載されているか確認</p>
          <p>→ 表示がない場合、アクセスが許可されていないアプリにfit、&wellが表示されているのでタップして許可してください</p>

          <h3>②共通 Google fitでヘルスコネクトとの同期を確認</h3>
          <p>1.Google fitアプリを起動</p>
          <p>2.右下のプロフィールアイコンをタップ</p>
          <p>3.右上の歯車アイコンをタップ</p>
          <p>4.ヘルスコネクトの「Fitとヘルスコネクトを同期する」がON＝右側に○が表示されていること</p>
          <p>→右側に○が表示されていない場合は○をタップ</p>
          <p>→「Fitとヘルスコネクトを同期する」を許可</p>
          <p>→Fitにヘルスコネクトへのアクセスを許可に関する表示が出るので、「すべてを許可」を選択して連携してください。</p>
          <br>
          <p>上記実施後も歩数が連携されない場合、アプリフリーズの可能性がございますので、以下の手順をお試しください。</p>
          <p><a href="#a9005">アプリフリーズの場合</a></p>
          `,
        },
        {
          id: 3003,
          title: 'ログインしていますが、歩数が連携できません。（Fit bitとの連携方法）',
          html: `
          <h3>■Fitbit連携方法の確認</h3>
          <p>以下URLをご確認ください</p>
          <p>https://go.andwell.jp/files/2024/download_and_login.pdf</p>
          <p>※iPhoneご利用の場合はP13～</p>
          <p> Androidご利用の場合はP20～ご確認ください。</p>

          <h3>■Fitbitアカウントの確認</h3>
          <p>①fitbitアプリを開き、ログインしているfitbitアカウント（メールアドレス）を確認ください</p>
          <p>※Googleアカウントでログインしている場合、fitbitアプリの右上、プロファイル画像部分をクリックいただくと、ログインしているメールアドレスが表示されます。</p>
          <p>※fitbitアプリ上で、問題なく歩数が計上されているか念のためご確認ください</p>
          <p>②&wellアプリを開き、外部アプリ連携の解除</p>
          <p>アプリ右上の歯車マーク</p>
          <p>→マイページの「データ連携」</p>
          <p>→「連携している外部アプリ」（fitbitと表示されているかと思います）</p>
          <p>→一度解除をお願いいたします。</p>
          <p>③②で解除すると、外部アプリ選択画面となりますので、「fitbit」を選択</p>
          <p>そこでログインする際に、①で確認したfitbitアカウントをご入力ください。</p>

          <h3>■アプリフリーズの確認</h3>
          <p>以下の項目を1つずつ実施していただき、その都度、連携されているかご確認ください。</p>
          <p>①アプリを終了する。</p>
          <p>※終了する方法は、検索サイトで「お使いの携帯電話（【Android or iPhone】）」と「アプリを終了させる方法」などと入力し検索すると確認できます。</p>
          <p>②アプリからログアウトし、再ログインする。</p>
          <p>③スマートフォンの電源を入れなおす。</p>
          <p>④キャッシュクリアする。</p>
          <p>⑤アプリをアンインストール → 再インストール</p>
          <p>1）&wellアプリをログアウト</p>
          <p> ※ログアウトしないで再インストールを行うとデータが残ってしまってログインが完了しない場合があるため、</p>
          <p>必ずアカウントのログアウトを実施してください。</p>
          <p>2）&wellアプリを削除</p>
          <p>3）&wellアプリを再度インストール</p>
          <p>  ※会社貸与の端末において、セキュリティ上の理由で任意でアプリのインストールができない場合がございます。</p>
          <p> QRコードが読み取れないなど発生した場合、企業の担当窓口へお問い合わせください。</p>
          <p>4）アプリにログインして、外部アプリにfitbitを選択</p>
          <p>5）fitbitのログインを実施</p>
          <p>※この際に、上記「Fitbitアカウントの確認」でご確認いただいた通り、fitbitアプリでログインしているfitbitアカウント（メールアドレス）を入力。</p>
          `,
        },
        {
          id: 3004,
          title: '携帯端末2台で利用できますか？',
          html: `
          <p>はい、ご利用いただけます。<br>
          携帯端末を2台お持ちの方は、以下の点に注意してください。</p>
          <h3>前提</h3>
          <ul>
            <li>2台の携帯端末で、&wellアプリを同一のアカウントでログインし使用している</li>
          </ul>
          <h3>2台持ちの例</h3>
          <ul>
            <li>平日は会社の携帯（1台目）、休日は個人の携帯（2台目）を使用</li>
            <li>どちらの端末も、&wellアプリと連携している外部アプリは同じ</li>
          </ul>
          <h3>手順例</h3>
          <ul class="simple-list mb-30">
            <li>
              <p>月曜日~金曜日</p>
              <p>1台目で&wellアプリを起動し歩く</p>
              <p>※翌日にアプリを起動し、前日までの歩数をアップロードする</p>
            </li>
            <li>
              <p>土曜日、日曜日</p>
              <p>2台目で&wellアプリを起動し歩く</p>
              <p>※翌月曜日にアプリを起動し、土日の歩数をアップロードする</p>
            </li>
          </ul>
          <h3>結果.</h3>
          <p>2つの端末で取得した歩数データを比べ、アプリ起動日14日前から多いほうの歩数が計上され、平均歩数が反映されます。</p>
          <p>※例えば、21日ぶりにアプリを起動した場合、直近14日間の歩数データを取得することはできますが、それ以前の7日間については歩数データを取得できません。</p>`,
        },
        {
          id: 3005,
          title: 'iPad・パソコンで&wellアプリを利用できますか？',
          html: `iPad・パソコンではご利用いただけません。スマートフォン（iPhoneまたはAndroid）でご利用ください。`,
        },
        {
          id: 3006,
          title: '接続できるウェアラブル端末は何がありますか？',
          html: `
          <p>&wellアプリと連携できる代表的なウェアラブル端末は、以下となります。</p>
          <p>例）</p>
          <ul>
          <li>Apple Watch</li>
          <li>Fitbit</li>
          <li>ガーミン など</li>
          </ul>
          <p class="mt-20">Fitbitは、Fitbit専用のアプリで直接連携できます。
          それ以外は「ヘルスケア」または「Google Fit」と連携できるウェアラブル端末であれば、&wellアプリと連携ができます。その際、別途コネクトアプリをダウンロードいただく必要がございます。
          コネクトアプリの詳細やウェラブル端末と「ヘルスケア」または「Google Fit」との連携方法に関しては、各メーカーのウェブサイト等をご確認いただくか、各メーカーまでお問い合わせください。
          </p>
          `,
        },
        {
          id: 3007,
          title: 'ウェアラブル端末と&wellアプリの歩数ログが一致しません。',
          html: `詳細はわかりかねますので、各メーカーへお問い合わせください。`,
        },
        {
          id: 3008,
          title: 'ウェアラブル端末とヘルスケア/Google Fitの歩数が一致しません。',
          html: `ウェラブル端末とヘルスケア/Google Fitとの連携方法に関しては、各メーカーHP等をご確認いただくか、各メーカーまでお問い合わせください。`,
        },
      ],
    },
    {
      id: 4000,
      title: '設定・公開範囲',
      content: [
        {
          id: 4001,
          title: '友だち申請を取り消すことはできますか？',
          html: `
          <p>あなたが友だちの申請をして、相手がまだ「承認」または「却下」をしていない場合、この時点では申請のキャンセルができません。</p>
          <p>相手が「承認」したあとは、ホーム画面の左上「≡」メニューの「友だち」を押下＞「友だちリスト」より削除することが可能です。<br>
          <br></p>
          <p>＜取り消し方法＞</p>
          <h3>iPhone（iOS）の場合</h3>
          <p>削除したい友達を右から左にスワイプすると「削除」ボタンが出てきます。</p>
          
          <h3>Androidの場合</h3>
          <p>削除したい友達を長押しすると、削除のダイアログがでてきます。</p>`,
        },
        {
          id: 4002,
          title: '友だちには、自分のどんな情報が公開されますか？',
          html: `
          <p>いいね！を押したコンテンツや参加したプログラム、達成したミッションが公開されます。</p>
          <p class="mt-20">
          表示例）<br>
          〇さんが6,000歩歩こう！を達成しました。<br>
          〇さんが【4/1開催】モーニングストレッチを閲覧しよう！を達成しました。<br>
          </p>`,
        },
        {
          id: 4003,
          title:
            'つながった友だちに、自分のタイムラインを公開しない方法を教えてください。',
          html: `タイムラインを非公開にすることはできません。`,
        },
        {
          id: 4004,
          title:
            '登録アドレスにお知らせなどのメールが届きます。配信停止の方法を教えてください。',
          html: `<h3>アプリで配信停止の設定をする場合</h3>
          <p>ホーム画面の右上の歯車マークを押下＞マイページのメールマガジン設定＞受け取らないを押下＞OKを押下</p>
          
          <h3>会員サイトで配信停止の設定をする場合</h3>
          <p>ログイン後トップページの右上のアイコンを押下＞マイページの設定部分のメールガマガジン設定を押下＞受け取らないを押下＞×部分を押下し閉じる</p>
          
          <p class="mt-20">※配信停止後、しばらくメールが届く場合がありますのでご了承ください。</p>`,
        },
        {
          id: 4005,
          title: 'プロフィール写真の編集ができなくなりました。',
          html: `<h3>アプリで編集できます。</h3>
          <p>ホーム画面の右上の歯車マークを押下＞マイページのカメラアイコンまたは写真を押下して、変更することができます。<br>
          それでも変更できない場合は、以下の手順で試してください。
          </p>
          <ol>
          <li>ログアウト＞再ログイン</li>
          <li>スマートフォンの電源をOFF＞電源をON</li>
          <li>アプリをアンインストール（削除）＞再インストール後にログイン</li>
          </ol>`,
        },
        {
          id: 4006,
          title: 'ニックネームの変更方法を教えてください。',
          html: `<h3>アプリで変更できます。</h3>
          <p>ホーム画面の右上の歯車マークを押下＞マイページの下記を押下すると編集できます。</p>
          <ul>
          <li>ニックネーム（上部）</li>
          <li>基本情報（テキスト）</li>
          <li>基本情報内（性別・生年・身長）</li>
          </ul>`,
        },
      ],
    },
    {
      id: 5000,
      title: '機種変更',
      content: [
        {
          id: 5001,
          title:
            'スマートフォンを機種変更する予定です。データを引き継ぐにはどうすればよいですか？',
          html: `
          <p>機種変更後の端末に&wellアプリをダウンロードし、既存のアカウントでログインをしてください。<br>
          また、連携している外部アプリに応じて設定を行うことで連携が可能です。</p>
      <h3>iOSの場合</h3>
      <h3 class="h3">＜ヘルスケア＞</h3>
      <p>機種変更を行う場合、他のデータ同様、事前にバックアップをとる必要があります</p>
  
      <h3 class="h3 mt-20">1）iCloudでバックアップをとる</h3>
      <ul class="mt-20">
        <li>
          機種変更前の端末
          <ol>
            <li>「設定」＞ユーザー名＞「iCloud」の順に押下する。</li>
            <li>「iCloudバックアップ」を押下し「iCloudバックアップ」をオンにした状態で、「今すぐバックアップを作成」を押下しバックアップ作成。</li>
          </ol>
        </li>
        <li class="mt-20">
          機種変更後の端末
          <ol>
            <li>「新しいiPhoneとして設定」を押下して、初期設定をする。</li>
            <li>「iPhone バックアップ」という画面が表示されるので、「ほかのバックアップを選択、または復元しない」を押下する。</li>
            <li>すでにバックアップは保存済みなので「iCloudバックアップから復元」を押下する。</li>
            <li>Apple IDとパスワードを入力して「次へ」を押下。バックアップに使用するデータを選択する。復元が完了すると「復元しました」と表示される。</li>
          </ol>
        </li>
      </ul>
      <p class="mt-20">上記の操作を行う事で以前のヘルスケアデータが引き継がれます。</p>
  
      <h3 class="h3 mt-20">2）PCでバックアップをとる</h3>
      <ol class="mt-20">
        <li>iPhoneをPCにつなぎ、「信頼」を押下し、パスコードを入力する。</li>
        <li>iPhoneを接続すると、iTunesの画面左上にiPhoneのアイコンが表示される。</li>
        <li>
          「このコンピュータ」にチェックを付け、「今すぐバックアップ」をクリックする。
          <p>※このとき、<strong>ヘルスケアデータ</strong>もバックアップして引き継ぐには、「iPhoneのバックアップを暗号化」にチェックを付ける。</p>
        </li>
      </ol>
      <ul class="simple-list mt-20">
        <li>
          機種変更前の端末
          <ol>
            <li>「設定」＞ユーザー名＞「iCloud」＞「iPhoneを探す」の順に押下する。</li>
            <li>「iPhoneを探す」をオフにして、Apple IDのパスワードを入力。「オフにする」を押下する。</li>
            <li>PCの「iTunes」を起動し、画面左上の「iTunes」＞「環境設定」＞「デバイス」の順にクリックし、「iPod、iPhone、およびiPadを自動的に同期しない。」にチェックを付けて「OK」をクリックする。</li>
          </ol>
        </li>
        <li class="mt-20">
          機種変更後の端末
          <ol>
            <li>「新しいiPhoneとして設定」を押下して、初期設定をする。</li>
            <li>PCにiPhoneを接続したら、「このバックアップから復元」にチェックを付け、復元するデータを選択したら「続ける」を押下する。</li>
          </ol>
        </li>
      </ul>
      <p class="mt-20 mb-20">上記の操作を行う事で以前のヘルスケアデータが引き継がれます。</p>
  
      <h4>＜Fitbit＞</h4>
      <p>Fitbitはアカウントでの管理をしているので、機種変更後のアプリで外部アプリ（Fitbit）を選択し、同様のFitbitアカウントでログインすれば以前の歩数が表示されます。</p>
  
      <h3>Android</h3>
      <h4>＜Google Fit＞</h4>
      <p>Google Fitはアカウントでの管理をしているので、機種変後のアプリで外部アプリ（Google Fit）を選択し、同様のGoogle Fitアカウントでログインすれば以前の歩数が表示されます。</p>
  
      <h4>＜Fitbit＞</h4>
      <p>Fitbitはアカウントでの管理をしているので、機種変更後のアプリで外部アプリ（Fitbit）を選択し、同様のFitbitアカウントでログインすれば以前の歩数が表示されます。</p>`,
        },
        {
          id: 5002,
          title: "機種変更したら、ログインアカウントがわからなくなりました。",
          html: `<p>「<a href="#a2001">アカウント・パスワードを忘れてしまいました。</a>」をご確認ください。</p>
          <p>上記ご確認後も不明な場合、企業または健康保険組合の担当窓口へお問い合わせください。</p>`,
        },
      ],
    },
    {
      id: 6000,
      title: 'ウォーキングイベント・歩数',
      content: [
        {
          id: 6001,
          title: 'ウォーキングイベント（個人チャレンジ）の参加方法などマニュアルはありますか',
          html: `ルールブック・マニュアルは&wellアプリ内「お知らせ」または「開催概要」からご確認ください。`,
        },
        {
          id: 6002,
          title: 'ウォーキングイベント（チーム対抗戦）の参加方法などマニュアルはありますか？',
          html: `ルールブック・マニュアルは&wellアプリ内「お知らせ」または「開催概要」からご確認ください。`,
        },
        {
          id: 6003,
          title: '車いす（または、歩行が不安定）でもウォーキングイベントに参加できますか？',
          html: `<p>はい、参加できます。<br>
          歩数のカウント方法を、企業または健康保険組合の担当窓口へご相談ください。</p>`,
        },
        {
          id: 6004,
          title: 'チームの作成方法が分かりません。',
          html: `「チーム編成マニュアル」をご確認ください。`,
        },
        {
          id: 6005,
          title: 'チームへの参加申請方法が分かりません。',
          html: `「チーム編成マニュアル」をご確認ください。`,
        },
        {
          id: 6006,
          title: 'ウォーキングイベントのエントリーボタンが表示されません。',
          html: `<p>エントリーボタンの表示につきましては、所属企業の&well担当者様にて対応となります。</p>
          <p>念のため所属企業の&wellをご利用されている方にお声がけいただき、エントリーボタンが表示されているかご確認ください。</p>
          <p>他の方も表示されていない場合、所属企業の&well担当者様へお問い合わせください。</p>

          <p>他の方はエントリーボタンが表示されている場合、ご自身のログインアカウントに誤りがある可能性がございます。</p>
          <p>ログインアカウントは、メールアドレスか英数字文字列のどちらかになります。</p>
          <p>お手数ですが一度アプリよりログアウトし、ご自身に付与されたアカウント形式をお確かめのうえ再ログインをお試しください。</p>
          <p>1.アプリ右上の「設定マーク」を押下</p>
          <p>2.画面が遷移したら、下へスクロールし「ログアウト」を押下</p>
          <p>ログイン画面に遷移したらログインアカウント名に誤りがないか確認し、再ログインをしてください。</p>
          <p>※iPhoneなど、スペルチェックをして自動変換してしまう機能がありますのでご注意ください。</p>
          <p>※全角と半角の区別があっているかご確認ください。</p>`,
        },
        {
          id: 6007,
          title: 'ウォーキングイベントの参加登録期間を過ぎていますが、途中参加できますか？',
          html: `システムの仕様上、途中参加できかねます。`,
        },
        {
          id: 6009,
          title: '参加メンバーをキャンセルさせたいです。どうすればよいですか？',
          html: `<p>チーム対抗戦開始後は、メンバーの変更ができません。</p>

          <p>なお、アプリでチーム編成する場合、チームが成立すると開始前でもメンバーの変更ができません。ただし、チーム成立前はメンバーの変更ができます。詳細は「従業員向けマニュアル」をご確認ください。</p>`,
        },
        {
          id: 6010,
          title:
            'チームリーダーです。不明なユーザーからチームへの参加申請がありました。確認方法はありますか？',
          html: `<p>事務局では、個人の特定、対象者にアプリ内でメッセージを送ることもできません。同時に2チーム以上の参加申請はできないため、周りの方々にお声がけいただき、心当たりがない場合は、参加申請を「却下」することをお勧めしています。なお、不明なユーザーから申請がこないように、チーム作成時に公開範囲を「限定」にすることも可能です。</p>

          <p>公開範囲設定方法は「チーム編成マニュアル」をご確認ください。</p>`,
        },
        {
          id: 6011,
          title: '他社のユーザーとチームを組むことはできますか？',
          html: `企業をまたいでチームを組むことは出来ません。チームは企業内で編成してください。`,
        },
        {
          id: 6012,
          title: 'チーム名の変更はできますか？',
          html: `<p>≪参加登録期間中≫の変更は可能です。変更方法はチーム編成方法によって異なります</p>
          <h3>【企業&wellご担当者様にてチーム編成:csv登録】</h3>
          <p>チーム名を変更したcsvを再度ご登録ください。企業&wellご担当者様へお問い合わせください</p>
          <h3>【&wellアプリより従業員様にてチーム編成:アプリ登録】</h3>
          <p>従業員の方ご自身で<u>チーム成立前のみ</u>アプリ上で変更可能です。</p>

          <p>なお、≪開催中≫はチーム編成方法に関係なく変更できません。</p>`,
        },
        {
          id: 6013,
          title: '個人の歩数ログは記録が表示されますが、所属チームの記録には０歩と表示されます。',
          html: `チーム対抗戦専用ページ（個人チャレンジ専用ページ）の平均歩数は、アプリ立ち上げから歩数反映まで一定時間がかかります。`,
        },
        {
          id: 6014,
          title:
            'ウォーキングイベントに参加していますが、歩数が正しく反映されません。',
          html: `<p>歩数が反映されていない箇所により、下記①または②をご確認ください。</p>

          <h3>①アプリホーム画面の「今日の歩数」が反映されない</h3>
          <p>下記URLより「歩数が反映されなくなりました。」をご確認ください。</p>
          <p>https://go.andwell.jp/faq#a9004</p>

          <h3>②「チーム対抗戦専用ページ（個人チャレンジ専用ページ）」の「前日の歩数」が反映されない</h3>
          <p>チーム対抗戦専用ページ（個人チャレンジ専用ページ）の平均歩数は、アプリ立ち上げから歩数反映まで一定時間がかかります。</p>`,
        },
        {
          id: 6015,
          title: '自動チーム作成を選択しましたが、別のチームに入り直したいです。',
          html: `<p>一度「自動チーム作成」ボタンを押し申請すると、成立・未成立に関わらずキャンセルができかねます。</p>
          
          <p>※例外として、自動チーム参加人数が所属する企業内で7名未満となった場合のみ、</p>
          <p>エントリー期間最終日に自動チーム編成が解除され、別チームに参加申請できるようになります。</p>
          <p>自動チーム編成での参加者が7名以上となり、チームが成立した場合は、解除とはなりません。</p>`,
        },
        {
          id: 6016,
          title: '歩数ログとチーム対抗戦（または個人チャレンジ）で表示される歩数が異なるのはなぜですか？',
          html: `<p>アプリホーム画面に表示される歩数ログとチーム対抗戦（または、個人チャレンジ）専用ページの平均歩数は集計期間が異なります。</p>

          <h3>アプリホーム画面</h3>
          <p>月曜日から1週間の平均歩数です。本日分を含んでいます。</p>

          <h3>チーム対抗戦（または、個人チャレンジ）専用ページ</h3>
          <p>期間中の前日分までの平均歩数です。本日分は含まれていません。</p>`,
        },
        {
          id: 6017,
          title: '入賞賞品が届きません。',
          html: `<p>迷惑メールフォルダなどに振り分けられている可能性もございますのでご確認ください。</p>
          <p>見つからない場合は、お手数ですが&well事務局へお問い合わせください。</p>
          <p>なお、お問い合わせの際は下記をご連絡ください。</p>
          <p>・氏名</p>
          <p>・ニックネーム</p>
          <p>・&wellアプリログインアカウント</p>
          <p>・所属企業</p>
          <p>・賞品名</p>
          <p>・送付先住所またはアドレス</p>
          <p>・どのイベント入賞賞品か</p>`,
        },
      ],
    },
    {
      id: 7000,
      title: 'ポイント交換（賞品発送）',
      content: [
        {
          id: 7001,
          title: 'ポイント交換商品が届きません。',
          html: `<p>ポイント交換商品の送付スケジュールは以下の通りです。</p>
          <p>①申込日：1日～15日⇒翌月中旬頃発送</p>
          <p>②申込日：16日～末日⇒翌月下旬頃発送</p>

          <p>迷惑メールフォルダなどに振り分けられている可能性もございますのでご確認ください。</p>

          <p>発送予定日を過ぎており、迷惑メールフォルダにもない場合はお手数ですが&well事務局へお問い合わせください。</p>
          <p>なお、お問い合わせの際は下記をご連絡ください。</p>
          <p>・氏名</p>
          <p>・ニックネーム</p>
          <p>・&wellアプリログインアカウント</p>
          <p>・所属企業</p>
          <p>・応募日時※</p>
          <p>・応募された商品名※</p>
          <p>・送付先住所またはアドレス</p>
          <p>※応募日時・商品名につきましては、アプリホーム画面「保有ポイント」押下＞画面上部「応募履歴」よりご確認いただけます。</p>`,
        },
        {
          id: 7002,
          title: 'ポイント交換商品の選択を間違えました。変更できますか？',
          html: `ご応募済みの商品を変更することはできかねます。`,
        },
        {
          id: 7003,
          title: 'ポイント交換キャンペーンで、ポイントを使った賞品に応募というのは、応募をするだけでポイントを使うということでしょうか？',
          html: `<p>抽選の賞品で応募いただいたポイントは、当落選に関わらず、応募した時点でポイントを利用した（＝ポイントを使った）ことになります。</p>`,
        },
        {
          id: 7005,
          title: '賞品の発送先を入力したのですが確認できません。確認方法を教えてください。',
          html: `<p>入力した送付先情報の内容は、アプリ上では確認することはできませんので、お手数ですが&well事務局へお問い合わせください。</p>
          <p>なお、お問い合わせの際は下記をご連絡ください。</p>
          <p>・氏名</p>
          <p>・ニックネーム</p>
          <p>・&wellアプリログインアカウント</p>
          <p>・所属企業</p>
          <p>・賞品名</p>
          <p>・送付先住所またはアドレス</p>
          <p>・ポイント交換商品かイベント入賞賞品か</p>`,
        },
      ],
    },
    {
      id: 8000,
      title: '異動・退職時について',
      content: [
        {
          id: 8001,
          title:
            '異動で会社が変わります。そのまま&wellを利用することはできますか？',
          html: `企業（または健康保険組合）の担当窓口までご確認ください。`,
        },
        {
          id: 8002,
          title: '退職します。そのまま&wellを利用することはできますか？',
          html: `企業（または健康保険組合）の担当窓口までご確認ください。`,
        },
      ],
    },
    {
      id: 9000,
      title: '不具合・困ったら',
      content: [
        {
          id: 9001,
          title: 'ログインができません。',
          html: `<p>ログインできない場合、以下をお試しください。</p>

          <p>1.ログインアカウントは、メールアドレスか英数字文字列のどちらかになります。ご自身に付与されたアカウント形式をお確かめのうえ、入力しているアカウント、パスワードが正しいかご確認ください。</p>
          <p>2.「テナントユーザーとして登録されていません」などが表示される場合、誤入力の可能性があります。スマートフォンで入力の際は全ての文字を手入力していただき、「＠」や「.」が半角であることをご確認ください。</p>
          <p>※iPhoneなど、スペルチェックをして自動変換してしまう機能がありますのでご注意ください。</p>

          <p>上記ご対応後もログインできない場合は、</p>
          <p>PCにて以下URLの会員サイトからログインをお試しください。</p>
          <p>https://go.andwell.jp/</p>`,
        },
        {
          id: 9002,
          title: 'パスワードを再設定しても、再度ログインを要求されます。',
          html: `&wellアプリを一旦終了させ、再起動をしてから再度ログインをお試しください。`,
        },
        {
          id: 9003,
          title: 'アプリのホーム画面の一部が表示されません。',
          html: `<p>ログインしているアカウントに誤りがある可能性があります。</p>
          <p>ログインアカウントは、メールアドレスか英数字文字列のどちらかになります。</p>
          <p>お手数ですが一度アプリよりログアウトし、ご自身に付与されたアカウント形式をお確かめのうえ再ログインをお試しください。</p>
          <p>1.アプリ右上の「設定マーク」を押下</p>
          <p>2.画面が遷移したら、下へスクロールし「ログアウト」を押下</p>
          <p>ログイン画面に遷移したら。ログインアカウント名に誤りがないか確認し、再ログインをしてください。</p>
          <p>※iPhoneなど、スペルチェックをして自動変換してしまう機能がありますのでご注意ください。</p>
          <p>※全角と半角の区別があっているかご確認ください。</p>

          <p>上記ご対応後も不具合が解消されない場合は、&well事務局へお問い合わせください。</p>`,
        },
        {
          id: 9004,
          title:
            'アプリの入力フォームにメールアドレスを入力すると「形式が正しくありません」と表示されてしまいます。',
          html: `<p>メールアドレスに誤りはないですか？</p>
          <p>多くの方がテキストの入力ミスであることが多く、下記2点を確認し、再入力をしてください。</p>
          <p>1.「@」も含め、全角と半角の区別があっているか</p>
          <p>2.自動変換はされてないか。iPhoneなど、スペルチェックをして自動変換してしまう機能があるため一文字ずつご入力いただくなど、お試しください。</p>`,
        },
        {
          id: 9005,
          title: 'アプリが起動できません。',
          html: `<p>アプリがフリーズしている可能性がございます。以下の手順でお確かめください。</p>
          <p>1.アプリを終了する。</p>
          <p>※終了する方法は、検索サイトで「お使いの携帯電話（iPhone or Android）」と「アプリを終了させる方法」などと入力し検索すると、確認できます。</p>
          <p>2.アプリからログアウトし、再ログインする。</p>
          <p>3.スマートフォンの電源を入れなおす。</p>
          <p>4.アプリをアンインストールし、再インスト―ルする。</p>`,
        },
        {
          id: 9006,
          title: '歩数が反映されません。',
          html: `<p>「外部アプリと連携ができていない」または「アプリがフリーズしている」可能性があります。</p>

          <p>外部アプリとの連携確認方法については使用端末に応じて以下をご確認ください。</p>
          <p>・<a href="#a3001">iPhone（iOS）をご利用の場合</a></p>
          <p>・<a href="#a3002">Androidをご利用の場合</a></p>
          <p>・<a href="#a3003">Fitbitをご利用の場合</a></p>
          
          <p>アプリがフリーズしている場合は、以下の手順でお確かめください。</p>
          <p>例）1.アプリを終了する。→連携されているか歩数を確認</p>
          <p> 1.アプリを終了する。</p>
          <p>※終了する方法は、検索サイトで「お使いの携帯電話（iPhone or Android）」と「アプリを終了させる方法」などと入力し検索すると、確認できます。</p>
          <p> 2.アプリからログアウトし、再ログインする。</p>
          <p> 3.スマートフォンの電源を入れなおす。</p>
          <p> 4.アプリをアンインストールし、再インスト―ルする。</p>`,
        },
        {
          id: 9007,
          title: '＆wellアプリや事務局からのメールが届きません。',
          html: `<p>以下の確認をお願いします。</p>
          
          <h3>1.受信制限の設定をしていませんか？</h3>
          <p>
          ご登録しているメールアドレスがキャリアメールの場合、各キャリアの下記迷惑メール対策により、メールが正しく届かない場合があります。<br>
          「指定ドメインからのメールのみ受信許可している」または「キャリア提供の迷惑メール対策の強度が強い」場合は、ドメイン【 andwell.jp 】を受信できるよう設定をお願いします。<br>
          設定方法はご利用キャリアのウェブサイトにて確認してください。
          </p>
          <h3>2.登録されたメールアドレスに誤りはないですか？</h3>
          <h3>3.迷惑メールフォルダや「ゴミ箱」に振り分けられていませんか？</h3>
          <p>
          お使いのセキュリティソフト、メールソフトによって、スパムメール(迷惑メール)と判断されている場合があります。<br>
          「メールの自動振り分け機能などの設定」や「迷惑メールフォルダ」を確認してください。
          </p>
          <h3>4.受信メールボックスの容量が一杯になっていませんか？</h3>
          <p>メールの受信可能容量を確認し、調整ください。</p>`,
        },
        {
          id: 9008,
          title: '電話で問い合わせしたいです。',
          html: `<p>&wellに関するお問い合わせは専用フォームにてご対応しています。<br>
          お手数をおかけしますが、まずはお問い合わせ内容を専用フォームまでご連絡ください。<br>
          なお、お問い合わせ内容により、事務局よりお電話をする場合もあります。</p>`,
        },
      ],
    },
  ],
  en: [
    {
      id: 1000,
      title: 'First time login',
      content: [
        {
          id: 1001,
          title: 'Is there a manual available?',
          html: `&well App Login Manual 
<a href="/files/2024/download_and_login_en.pdf" target="_blank">Download and Login Manual</a>`,
        },
        {
          id: 1002,
          title: 'Where can I download the &well app?',
          html: `
          <p>Scan the QR code below with the QR code reader on your device to go to the app store. Alternatively, do so using the URL below.</p>
          <div class="col2 mt-30">
            <div style="margin-right:30px;">
              <b>iPhone (iOS) users</b>
              <p>Install from the App Store</p>
              <p><a href="https://apps.apple.com/jp/app/well/id1434515379" target="_blank">LINK</a></p>
              <img src="img/faq/ios.png" width="160" alt="iPhone">
            </div>
            <div>
              <b>Android users</b>
              <p>Install from Google Play</p>
              <p><a href="https://play.google.com/store/apps/details?id=jp.andwell" target="_blank">LINK</a></p>
              <img src="img/faq/android.png" width="160" alt="android">
            </div>
          </div>
          <br>
          <p>Note: For security reasons, it may not be possible to install the app on company-loaned devices in some cases.<br>
          If the QR code is unreadable, please contact your company or health insurance association's representative.</p>`,
        },
        {
          id: 1003,
          title: "I'm registering as a new member for the first time and don't know my account name or password. What should I do?",
          html: `
          <h3>For those who do not know their account:</h3>
          <p>The initial login account will be either your email address or an alphanumeric string. Please check the &well information provided via email or other means by your affiliated company or health insurance association. If you are unsure, please contact the responsible department of your company or health insurance association.</p>

          <h3>For those who do not know their password:</h3>
          <p>If your account is an email address, an initial password is not required.<br>
          If your account is an alphanumeric string, please refer to the instructions provided by your company or health insurance association. If you are unsure, please contact the responsible department of your company or health insurance association.</p>`,
        },
        {
          id: 1004,
          title: "I logged in, but I can't get to the app's home screen from the \"What is &well?\" screen. What should I do?",
          html: `If you swipe left a few times to go through the &well guidance screens, a final screen will appear that says "Link with Asken." 
          <br>Press the "Next" button at the bottom of that screen to move to the home screen.`,
        },
        {
          id: 1005,
          title: "While setting up the &well app, it asks me to download another app called Health (or Google Fit). Do I have to download it?",
          html: `
          <h3>For iPhone (iOS) Users:</h3>
          <p>The "Health" app is a standard pre-installed app on iPhone (iOS). There is no need to install it.</p>

          <h3>For Android Users:</h3>
          <p>You need to download the "Google Fit" app. Logging in with a Google account is required.</p>
          <p>Note: To use "Google Fit," it is necessary to link both the "Google Fit" app and the "&well app" with the "Health Connect" app.</p>`,
        },
        {
          id: 1006,
          title: "Is my account name and password the same on both the &well app and &well members website?",
          html: `Yes, your account name and password are the same.`,
        },
        {
          id: 1007,
          title: "Can I use the &well app only?",
          html: `Yes, you can do so.`,
        },
        {
          id: 1008,
          title: "Can I use the &well members website only?",
          html: `Yes, you can do so. You'll mainly get access to videos, livestreams, and articles. 
          <br>However, you won't be able to complete missions, enter your steps or Self-Log on the website, or get steps unless you launch the app.`,
        },
        {
          id: 1009,
          title: "What language settings are available? How do I change it?",
          html: `Japanese and English (automatic translation) are available. 
          <br>See below for instructions on how to change it. 

          <h3>When changing the app language</h3>
          <p>Press the gear mark at the top right of the home screen > My Page's "Language" > Choose Japanese or English > Press OK</p>

          <h3>When changing the website language</h3>
          <p>After logging in, press the icon at the top right of the main page > My Page's "Language" > Press Japanese or English > Press the × button to close</p>`,
        },
      ],
    },
    {
      id: 2000,
      title: 'Account, password, and registered address',
      content: [
        {
          id: 2001,
          title: 'I forgot my account name/password.',
          html: `
          <h3>For those who have forgotten their account:</h3>
          <p>The login account will be either your email address or an alphanumeric string. If you are unsure, please contact the HR (General Affairs) department of your affiliated company or the responsible department of your health insurance association.</p>
          <p>If you do not know the contact information, please reach out to the &well office.</p>

          <h3>For those who have forgotten their password:</h3>
          <p>You can reset or change your password <a href="https://go.andwell.jp/resetPassword">here</a>.</p>
          `,
        },
        {
          id: 2002,
          title: 'I want to change my registered email address.',
          html: `
          <p>If your account is an email address, it cannot be changed.<br>
          If your account is an alphanumeric string, you can change the registered email address.</p>

          <p>Tap the gear icon in the top right corner of the home screen > "Check Email Address" on the My Page > Enter the email address you want to change to in the email address field > Tap "Change."<br>
          The type of account (email address or alphanumeric string) is determined by your company or health insurance association.</p>
          `,
        },
        {
          id: 2003,
          title: 'Is my password the same on both the &well app and &well members\' site?',
          html: `Yes, your password are the same.`,
        },
        {
          id: 2004,
          title: 'I would like to cancel my membership.',
          html: `For requests to withdraw from &well, please contact your company's &well representative.`,
        },
      ],
    },
    {
      id: 3000,
      title: 'Available devices and wearable devices',
      content: [
        {
          id: 3001,
          title: 'I\'m logged in, but I can\'t link my steps. (iPhone: How to link with Health on iOS)',
          html: `
          <p>Please follow the steps below to check.</p>
          <p class="mt-20">Steps:</p>
          <ol>
          <li>Check the &well app
          <li>Check your iPhone device
          </ol>

          <p class="mt-20">Detailed Steps:</p>
          <h3>1. How to check the &well app:</h3>
          <p>Press the gear icon in the top right corner of the home screen > Go to "My Page" and check the data linkage. Confirm that the linked external app is listed as "Health."</p>
          <p>If "Health" is not listed, press the linked external app, and a selection screen will appear. Please select "Health."</p>

          <h3>2. How to check your iPhone device:</h3>
          <p>(1) Check if the "Health" app itself is counting steps.</p>
          <p>Note: If the "Health" app is not counting steps, please follow the data settings steps described in (2) below.</p>
          <p>(2) Check the data settings for the "Health" app:</p>
          <p>Go to iPhone Settings > Health > Data Access & Devices > &well > Ensure that all buttons on the right are turned on (displayed in green).</p>
          
          <p>If there are no issues with the above, the &well app may be frozen. Please try the following steps:</p>
          <p>Example:</p>
          <p>1.Close the app → Check if the steps are linked.</p>
          <p>2.Close the app.</p>
          <p>Note: To learn how to close the app, search for "How to close apps on [your phone model (iPhone)]" on a search engine.</p>
          <p>3.Log out of the app and log back in.</p>
          <p>4.Restart your smartphone.</p>
          <p>5.Uninstall the app → Reinstall the app.</p>
          <p>Note: On company-provided devices, you may not be able to install apps freely due to security reasons. If issues such as being unable to scan the QR code occur, please contact your company's support desk.</p>

          <p>Please note that manually entered steps in external apps will not be reflected in the &well app due to its specifications.</p>
          <p>If the steps are still not linked after performing the above, try unlinking the external app and reconfiguring the "Health" app, then restart the app.</p>
          <p>Press the gear icon in the top right corner of the home screen > Go to "My Page" > Press the linked external app > A pop-up asking "Do you want to unlink?" will appear, press "Yes" > Select "Health" > Confirm that the linked external app is listed as "Health" > Restart the app.</p>
          `,
        },
        {
          id: 3002,
          title: 'I\'m logged in, but I can\'t link my steps. (How to link with Google Fit on Android)',
          html: `
          <p>Could you please check if Google Fit and the &well app are linked with the "Health Connect" app?</p>
          <br>
          <h3>■ How to confirm the "Health Connect" app linkage:</h3>
          <p>Please follow the steps in ① and ②. Note: The steps may vary depending on the OS version.</p>
          
          <h3>①-1: For Android OS 14 and above:</h3>
          <p>Go to Settings > Apps > Security and Privacy: Tap on Health Connect.</p>
          <p>In Health Connect, tap on App Permissions.</p>
          <p>Under App Permissions, tap on "Fit."</p>
          <p>Check if all permissions are set to "Allow."</p>
          <p>Confirm that "Fit" is displayed under apps with granted access.</p>
          <p>These steps are for preparation.</p>
          <p>→ Afterward, on the external linkage screen of &well, a prompt will appear asking for permission to allow &well access to Health Connect. Select "Allow All" to complete the linkage.</p>
          <p>6. In the Health Connect settings screen, tap on "App Permissions."</p>
          <p>7. Confirm that "Fit" and "&well" are listed under apps with granted access.</p>
          <p>→ If they are not displayed, check under apps without granted access, and tap on "Fit" and "&well" to grant permission.</p>
          
          <h3>①-2: For Android OS 9-13:</h3>
          <p>Search for "Health Connect" in the app list on your device.</p>
          <p>If "Health Connect" appears in the search results, tap on the link.</p>
          <p>3-a. If Health Connect is not installed, tap the "Install" button.</p>
          <p>→ Select "Try it out" → Add Google Fit under "App Permissions."</p>
          <p>3-b. If Health Connect is already installed, tap "Open."</p>
          <p>→ Add Google Fit under the app permissions in Health Connect.</p>
          <p>→ Afterward, on the external linkage screen of &well, a prompt will appear asking for permission to allow &well access to Health Connect. Select "Allow All" to complete the linkage.</p>
          <p>4. In the Health Connect settings screen, tap on "App Permissions."</p>
          <p>5. Confirm that "Fit" and "&well" are listed under apps with granted access.</p>
          <p>→ If they are not displayed, check under apps without granted access, and tap on "Fit" and "&well" to grant permission.</p>
          
          <h3>② Common: Confirm synchronization with Health Connect in Google Fit:</h3>
          <p>Open the Google Fit app.</p>
          <p>Tap on the profile icon in the bottom right corner.</p>
          <p>Tap on the gear icon in the top right corner.</p>
          <p>Ensure that "Sync Fit with Health Connect" is turned ON (a circle is displayed on the right side).</p>
          <p>→ If the circle is not displayed on the right side, tap on it.</p>
          <p>→ Allow "Sync Fit with Health Connect."</p>
          <p>→ A prompt will appear asking for permission to allow Fit access to Health Connect. Select "Allow All" to complete the linkage.</p>
          <br>
          <p>If the steps above do not resolve the issue and steps are still not syncing, the app may be frozen. Please try the following steps:</p>
          <p><a href="#a9005">app freeze troubleshooting</a></p>
          `,
        },
        {
          id: 3003,
          title: 'I\'m logged in, but I can\'t link my steps.(How to link with Google Fit bit)',
          html: `
          <h3>■ How to Check Fitbit Linkage</h3>
          <p>Please refer to the following URL:</p>
          <p>https://go.andwell.jp/files/2024/download_and_login.pdf</p>
          <p>For iPhone users, please check from page 13.</p>
          <p>For Android users, please check from page 20.</p>
          
          <h3>■ Confirming Your Fitbit Account</h3>
          <p>1.Open the Fitbit app and check the Fitbit account (email address) you are logged into.</p>
          <p>Note: If you are logged in with a Google account, tap the profile image in the top right corner of the Fitbit app to display the email address you are logged in with.</p>
          <p>Also, please ensure that steps are being recorded correctly in the Fitbit app.</p>
          <p>2.Open the &well app and unlink the external app:</p>
          <p>・Tap the gear icon in the top right corner of the app.</p>
          <p>・Go to "My Page" > "Data Linkage."</p>
          <p>・Check the "Linked External App" (it should display "Fitbit").</p>
          <p>・Please unlink it once.</p>
          <p>3.After unlinking in step 2, the external app selection screen will appear. Select "Fitbit."</p>
          <p>・When logging in, enter the Fitbit account you confirmed in step 1.</p>
          
          <h3>■ Checking for App Freezing</h3>
          <p>Please perform the following steps one by one, and check after each step to see if the linkage is working:</p>
          <p>1.Close the app.</p>
          <p>Note: To learn how to close the app, search for "How to close apps on [your phone model (Android or iPhone)]" on a search engine.</p>
          <p>2.Log out of the app and log back in.</p>
          <p>3.Restart your smartphone.</p>
          <p>4.Clear the cache.</p>
          <p>5.Uninstall the app → Reinstall the app:</p>
          <p>1)Log out of the &well app.</p>
          <p>Note: If you reinstall the app without logging out, residual data may prevent successful login. Be sure to log out of your account first.</p>
          <p>2)Delete the &well app.</p>
          <p>3)Reinstall the &well app.</p>
          <p>Note: On company-provided devices, you may not be able to install apps freely due to security reasons. If issues such as being unable to scan the QR code occur, please contact your company's support desk.</p>
          <p>4)Log in to the app and select Fitbit as the external app.</p>
          <p>5)Log in to Fitbit.</p>
          <p>At this time, enter the Fitbit account (email address) you confirmed in the "Confirming Your Fitbit Account" section above.</p>
          `,
        },
        {
          id: 3004,
          title: 'Can I use the app on two mobile devices?',
          html: `
          <p>Yes, you can.</p>
          <p>If you have two mobile devices, please note the following:</p>
          
          <h3>Assumption</h3>
          <ul>
            <li>The same account is used to log in and use the &well app on the two mobile devices.</li>
          </ul>
          
          <h3>Example of having two devices</h3>
          <ul>
            <li>Use your company's mobile phone (first device) on weekdays and your own mobile phone (second device) on weekends.</li>
            <li>Both devices have the same external app linked with the &well app.</li>
          </ul>
          
          <h3>Example procedure</h3>
          <ul class="simple-list mb-30">
            <li>
              Monday to Friday
              <p>Launch the &well app on the first device when you walk.</p>
              <p>Note: Launch the app the next day and upload your steps for the previous day.</p>
            </li>
            <li>
              Saturday and Sunday
              <p>Launch the &well app on the second device when you walk.</p>
              <p>Note: Launch the app the following Monday and upload your steps for Saturday and Sunday.</p>
            </li>
          </ul>
          
          <h3>Results</h3>
          <p>The data acquired by the two devices will be compared, the higher of the steps from 14 days before to the date the app was launched on will be logged, and the average steps will be reflected.</p>
          <p>Note: For example, if you launch the app after not using it for 21 days, you'll be able to acquire the step data for the last 14 days, but not for the 7 days before that.</p>
          `,
        },
        {
          id: 3005,
          title: 'Can I use the &well app on an iPad or PC?',
          html: `The app isn't available for iPad or PC. Please use it on your smartphone （iPhone or Android）.`,
        },
        {
          id: 3006,
          title: 'What wearable devices can I link the app to?',
          html: `
          <p>The main wearable devices that you can link with the &well app include:</p>
          <p>E.g.:</p>
          <ul>
          <li>Apple Watch</li>
          <li>Fitbit</li>
          <li>Garmin, and others</li>
          </ul>
          <p class="mt-20">Fitbit can be directly linked with the Fitbit dedicated app.
          Other than Fitbit, any wearable device that can be connected to "Healthcare" or "Google Fit" can be connected to the &well app. In this case, you will need to download the Connect app separately.
          For details on the Connect App and how to connect your wearable device to "Healthcare" or "Google Fit", please refer to the website of the manufacturer or contact the manufacturer.
          </p>
          `,
        },
        {
          id: 3007,
          title:
            `The Step Log on the &well app doesn't match the pedometer on my wearable device.`,
          html: `Timing and other factors may cause differences in the step tallies. 
Please contact the device manufacturer for more specific information that we can't provide.`,
        },
        {
          id: 3008,
          title:
            `The step count on my wearable device does not match the step count in HealthCare/Google Fit.`,
          html: `For information on how to link wearable devices with Health/Google Fit, please refer to the respective manufacturer's website or contact the manufacturer directly.`,
        },
      ],
    },
    {
      id: 4000,
      title: 'Settings and disclosure range',
      content: [
        {
          id: 4001,
          title: 'Can I cancel a friend request?',
          html: `<p>If you sent a friend request and the other person has not yet approved or rejected it, you can't cancel it.</p>

<p>After that person has approved it, you can delete them from your Friends List by pressing the "≡" icon in the upper left corner of the app's home screen > Pressing "Friends" > and deleting them.</p>
<p>[How to delete friends]</p>
<ul>
<li>iPhone (iOS) users<br>
Swipe left on the friend that you want to delete, and the "Delete" button appears.</li>
<li>Android users<br>
Press and hold on the friend you want to delete, and the "Delete" dialogue appears.</li>
</ul>`,
        },
        {
          id: 4002,
          title: 'What information about me is shared with my friends?',
          html: `<p>The content you like, programs you participate in, and missions you complete are shared.</p>
<p>Display examples:</p>
<p>_ completed the "Walk 6,000 Steps!" mission.</p>
<p>_ completed the "[Starts 4/1] Watch the Morning Stretches!" mission.</p>`,
        },
        {
          id: 4003,
          title: 'How can I stop sharing my timeline with my friends?',
          html: `Timelines can't be made private.`,
        },
        {
          id: 4004,
          title: 'I keep getting notifications, etc. sent to my registered email address. How do I unsubscribe?',
          html: `<p>[Unsubscribing through the app settings]</p>
<p>Press the gear mark at the top right of the home screen > My Page's Mail Magazine settings > Press "Do not receive" > Press OK</p>

<p>[Unsubscribing through the members' site settings]</p>
<p>After logging in, press the icon at the top right on the main page > Press My Page's Mail Magazine settings > Press "Do not receive" > Press the × button to close</p>

<p>Note: Even after you unsubscribe, please understand that you may still receive emails for a short time.</p>`,
        },
        {
          id: 4005,
          title: 'I can\'t change my profile picture.',
          html: `<p>You can change it on the app.</p>
<p>Press the gear mark at the top right of the home screen > Press My Page's camera icon or your photo, and you'll be able to change it.</p>
<p>If you still can't change it, try the following steps:</p>
<ul>
<li>Log out > Log in again</li>
<li>Turn off your smartphone > Turn it on again</li>
<li>Uninstall the app > Reinstall it and log in again</li>
</ul>`,
        },
        {
          id: 4006,
          title: 'How do I change my nickname?',
          html: `<p>You can change it on the app.</p>
<p>Press the gear mark at the top right of the home screen>You can change it by pressing one of the following on My Page.</p>
<ul>
<li>Nickname (Top part)</li>
<li>Basic Information (Text)</li>
<li>Within Basic Data (Gender, Year of birth, Height)</li>
</ul>`,
        },
      ],
    },
    {
      id: 5000,
      title: 'Change of cell phone model',
      content: [
        {
          id: 5001,
          title: "I'm planning to get a different smartphone. How do I carry over my data?",
          html: `
          <p>Download the &well app to your new device and log in with your existing account. 
          External apps can also be linked by setting them up accordingly in settings. </p>

          <h3>■iPhone (iOS) users</h3>
          <h4>[Health]</h4>
          <p>When you change devices, you need to back up your data in advance, just like with any other data.</p>

          <h4>1) Back up with iCloud</h4>
          <ul class="simple-list mt-20">
            <li>Old device
              <ol>
                <li>Press "Settings" > User name > "iCloud."</li>
                <li>Press "iCloud Backup" to turn on "iCloud Backup." Then, press "Back Up Now" to create a backup.</li>
              </ol>
            </li>
            <li class="mt-20">New device
              <ol>
                <li>Press "Set Up as New iPhone" to set up your device.</li>
                <li>When the "Restore Your Apps and Data" screen appears, press "Choose Other Backup or Don't Restore."</li>
                <li>You've already saved a backup, so press "Restore from iCloud Backup."</li>
                <li>Enter your Apple ID and password and press "Next." Select the data you want to use for the backup. "Restored" appears when the device is restored.</li>
              </ol>
            </li>
          </ul>
          <p class="mt-20">Once you do the above, your previous Health data will be carried over.</p>

          <h4>2) Back up on a PC</h4>
          <ol class="ordered-list mt-20">
            <li>Connect your iPhone to your PC, press "Trust," and enter your passcode.</li>
            <li>When you connect your iPhone, the iPhone icon appears in the upper left corner of the iTunes screen.</li>
            <li>Check "This Computer" and press "Back Up Now."<br>
            Note: Check "Encrypt iPhone backup" to back up and carry over your Health data.</li>
          </ol>
          <ul class="simple-list mt-20">
            <li>Old device
              <ol>
                <li>Press "Settings" > User name > "iCloud."> "Find my iPhone."</li>
                <li>Turn off "Find My iPhone" and enter your Apple ID password. Press "Turn Off."</li>
                <li>Open iTunes on your PC and press "iTunes" > "Preferences" > "Devices" in the upper left corner of the screen, and then check "Prevent iPods, iPhones, and iPads from syncing automatically" and press "OK".</li>
              </ol>
            </li>
            <li class="mt-20">New device
              <ol>
                <li>Press "Set Up as New iPhone" to set up your device.</li>
                <li>After connecting your iPhone to your PC, check "Restore from this backup," select the data to restore, and press "Continue."</li>
              </ol>
            </li>
          </ul>
          <p class="mt-20">Once you do the above, your previous Health data will be carried over.</p>

          <h4>＜Fitbit＞</h4>
          <p>Since Fitbit manages data via accounts, you'll see your previous steps if you select the external app (Fitbit) in the app on your new device and log in with the same Fitbit account.</p>

          <h3>・Android users</h3>
          <h4>＜Google Fit＞</h4>
          <p>Since Google Fit manages data via accounts, you'll see your previous steps if you select the external app (Google Fit) in the app on your new device and log in with the same Fitbit account.</p>

          <h4>＜Fitbit＞</h4>
          <p>Since Fitbit manages data via accounts, you'll see your previous steps if you select the external app (Fitbit) in the app on your new device and log in with the same Fitbit account.</p>`,
        },
        {
          id: 5002,
          title: "After changing devices, I don't remember my login account name.",
          html: `Please refer to <a href="#a2001">"I forgot my account/password."</a>.
          If you are still unsure after checking the above, please contact the responsible department of your company or health insurance association.`,
        },
      ],
    },
    {
      id: 6000,
      title: 'Walking events and steps',
      content: [
        {
          id: 6001,
          title: 'Is there a manual available that explains how to join walking events (Individual Challenges) and other details about them?',
          html: `You can check the rulebook and manual from the "Notifications" or "Event Overview" section within the &Well app.`,
        },
        {
          id: 6002,
          title: 'Is there a manual available that explains how to join walking events (Team Competitions) and other details about them?',
          html: `You can check the rulebook and manual from the "Notifications" or "Event Overview" section within the &Well app.`,
        },
        {
          id: 6003,
          title: 'Can people in wheelchairs (or those with trouble walking) join walking events?',
          html: `Please contact your company or health insurance association's representative.`,
        },
        {
          id: 6004,
          title: "I don't know how to create a team.",
          html: `Please refer to the "Team Organization Manual."`,
        },
        {
          id: 6005,
          title: "I don't know how to request to join a team.",
          html: `Please refer to the "Team Organization Manual."`,
        },
        {
          id: 6006,
          title: 'The entry button for the walking event is not displayed.',
          html: `<p>The display of the entry button is managed by your company's &well representative.</p>
          <p>Please confirm with other users of &well within your company to check if the entry button is displayed.</p>
          <p>If the entry button is not displayed for others as well, please contact your company's &well representative.</p>
          <p>If the entry button is displayed for others, there may be an error with your login account.</p>
          <p>Your login account will either be your email address or an alphanumeric string.</p>
          <p>Please log out of the app once, verify the format of the account assigned to you, and try logging in again.</p>
          <ol>
            <li>Tap the "Settings Icon" in the top right corner of the app.</li>
            <li>Scroll down on the next screen and tap "Log Out."</li>
            <li>Once redirected to the login screen, check for any errors in your login account name and try logging in again.</li>
          </ol>
          <p>Note:</p>
          <ul>
            <li>Be cautious of features like spell check and auto-correction on devices such as iPhones.</li>
            <li>Ensure that full-width and half-width characters are used correctly.</li>
          </ul>`,
        },
        {
          id: 6007,
          title: 'The registration period for the walking event has ended. Can I still join midway?',
          html: `Due to system specifications, mid-term participation is not allowed.`,
        },
        {
          id: 6009,
          title: 'I want to remove a team member. What should I do?',
          html: `<p>Once the team competition begins, team members cannot be changed.</p>
          <p>Additionally, if teams are formed using the app, changes to team members cannot be made even before the competition starts once the team is finalized. However, changes to team members can be made before the team is finalized. For more details, please refer to the "Employee Manual."</p>`,
        },
        {
          id: 6010,
          title: "I'm a team leader. An unknown user has requested to join my team. Is there a way to check who it is?",
          html: `<p>The Administration can't identify individuals or send messages to specific individuals from within the app. It's not possible to request to join more than one team at a time, so we ask that you try talking to those around you first to see if it was anyone you know. If not, you can reject the request. Note that you can set your sharing to "Limited" when creating a team in order to avoid requests from unknown users.</p>
          <p>For instructions on how to set the visibility range, please refer to the "Team Formation Manual."</p>`,
        },
        {
          id: 6011,
          title: 'Can I form a team with users from other companies?',
          html: `You can't form a team with employees from other companies. Please organize a team within your own company.`,
        },
        {
          id: 6012,
          title: 'Can I change the team name?',
          html: `<p>Changes are possible during the "Registration Period." The method of making changes depends on the team formation process.</p>
          <h3>[Team Formation by Company & Well Representative: CSV Registration]</h3>
          <p>Please re-register the CSV file with the updated team name. Contact your Company & Well representative for assistance.</p>
          <h3>[Team Formation by Employees via the & Well App: App Registration]</h3>
          <p>Employees can make changes themselves via the app, but only before the team is finalized.</p>
          <p>Please note that changes cannot be made during the "Event Period," regardless of the team formation method.</p>`,
        },
        {
          id: 6013,
          title: "My Step Log is displaying my recorded steps, but my team's record shows 0 steps.",
          html: `It takes time for the average steps on the Team Competition's dedicated page (or Individual Challenge's dedicated page) to reflect your steps once you've launched the app.`,
        },
        {
          id: 6014,
          title: "Though I joined the walking event, my steps aren't being reflected.",
          html: `<p>See (1) or (2) below, depending on where your steps aren't being reflected.</p>

          <h3>(1) They're not reflected on "Today's Steps" on the app's home screen</h3>
          <p>Please see "My steps aren't being reflected" at the URL below.</p>
          <p>https://go.andwell.jp/faq#a9004</p>

          <h3>(2) They're not reflected on "Yesterday's Steps" on the "Team Competition's dedicated page (or Individual Challenge's dedicated page)"</h3>
          <p>It takes time for the average steps on the Team Competition's dedicated page (or Individual Challenge's dedicated page) to reflect your steps once you've launched the app.</p>`,
        },
        {
          id: 6015,
          title: 'I selected auto team creation, but I would like to join a different team.',
          html: `<p>Once the "Auto Team Creation" button is pressed and the application is submitted, it cannot be canceled, regardless of whether the team is finalized or not.</p>
          <p>Exception: If the number of participants in the auto team is fewer than 7 within the same company, the auto team formation will be canceled on the final day of the registration period, allowing participants to apply to join a different team.</p>
          <p>However, if the auto team has 7 or more participants and the team is finalized, it will not be canceled.</p>`,
        },
        {
          id: 6016,
          title: 'Why is the number of steps shown on the Step Log different from what\'s shown in the Team Competition (or Individual Challenge)?',
          html: `<p>The tallying periods are different for the Step Log displayed on the app's home screen and the average steps on the Team Competition's (or Individual Challenge's) dedicated page.</p>

          <h3>App home screen</h3>
          <p>This is the average number of steps per week, starting on Mondays. It includes the current day's steps.</p>

          <h3>Team Competition's (or Individual Challenge's) dedicated page</h3>
          <p>This is the average steps during the period, up to the previous day. It doesn't include the current day's steps.</p>`,
        },
        {
          id: 6017,
          title: 'The award prize has not arrived.',
          html: `<p>Please check if the email has been sorted into your spam or junk mail folder.</p>
          <p>If you cannot find it, kindly contact the &well support team.</p>
          <p>When reaching out, please provide the following information:</p>
          <ul>
            <li>Full Name</li>
            <li>Nickname</li>
            <li>&Well App Login Account</li>
            <li>Company Name</li>
            <li>Prize Name</li>
            <li>Delivery Address or Email Address</li>
            <li>The Event for Which the Prize Was Awarded</li>
          </ul>`,
        },
      ],
    },
    {
      id: 7000,
      title: 'Redeeming points (shipping prize)',
      content: [
        {
          id: 7001,
          title: 'The points redemption item has not arrived.',
          html: `<p>The delivery schedule for points redemption items is as follows:</p>
          <p>1. Application Date: 1st to 15th → Shipped around the middle of the following month</p>
          <p>2. Application Date: 16th to the end of the month → Shipped around the end of the following month</p>
          
          <p>Please check if the email has been sorted into your spam or junk mail folder.</p>
          
          <p>If the scheduled shipping date has passed and the email is not in your spam folder, kindly contact the &Well support team.</p>
          <p>When reaching out, please provide the following information:</p>
          <ul>
            <li>Full Name</li>
            <li>Nickname</li>
            <li>&well App Login Account</li>
            <li>Company Name</li>
            <li>Application Date*</li>
            <li>Name of the Redeemed Item*</li>
            <li>Delivery Address or Email Address</li>
          </ul>
          <p>*You can check the application date and item name by tapping "Points Balance" on the app's home screen and selecting "Application History" at the top of the screen.</p>`,
        },
        {
          id: 7002,
          title: 'I selected the wrong points redemption item. Can I change it?',
          html: `It is not possible to change the item you have already applied for.`,
        },
        {
          id: 7003,
          title: 'When I\'m exchanging points, can I put in multiple entries for the same item at the same time?',
          html: `<p>You can enter more than once.</p>
          <p>However, you can't enter more than once simultaneously. When you enter more than once within the same time period, you must send in each entry application one at a time.</p>`,
        },
        {
          id: 7005,
          title: 'I entered my delivery information to receive a prize, but I can\'t check it. How do I check it?',
          html: `<p>The delivery information you entered cannot be viewed within the app.</p>
          <p>If you have any inquiries, please contact the &well support team.</p>
          <p>When reaching out, please provide the following information:</p>
          <ul>
            <li>Full Name</li>
            <li>Nickname</li>
            <li>&Well App Login Account</li>
            <li>Company Name</li>
            <li>Prize Name</li>
            <li>Delivery Address or Email Address</li>
            <li>Whether it is a points redemption item or an event award prize</li>
          </ul>`,
        },
      ],
    },
    {
      id: 8000,
      title: 'At the time of transfer or retirement',
      content: [
        {
          id: 8001,
          title: "I'm moving to a different company. Can I still use &well?",
          html: `Please contact your company (or health insurance association)'s representative.`,
        },
        {
          id: 8002,
          title: "I'm quitting my job. Can I still use &well?",
          html: `Please contact your company (or health insurance association)'s representative.`,
        },
      ],
    },
    {
      id: 9000,
      title: 'Problems and Troubleshooting',
      content: [
        {
          id: 9001,
          title: "I can't log in.",
          html: `<p>If you are unable to log in, please try the following steps:</p>
          <ol>
            <li>Your login account will either be your email address or an alphanumeric string. Verify the format of the account assigned to you and ensure that the account and password you are entering are correct.</li>
            <li>If a message such as "You are not registered as a tenant user" appears, it may be due to incorrect input. When entering information on a smartphone, please manually input all characters and ensure that symbols like "@" and "." are in half-width format.</li>
          </ol>
          <p>Note: Be cautious of features like spell check and auto-correction on devices such as iPhones.</p>
          <p>If you are still unable to log in after following the steps above, please try logging in via the member site on a PC using the following URL:</p>
          <p>https://go.andwell.jp/</p>`,
        },
        {
          id: 9002,
          title: "Even after resetting my password, the app keeps asking me to log in again.",
          html: `Please close the &well app, restart it, and try logging in again.`,
        },
        {
          id: 9003,
          title: "Some parts of the app's home screen aren't showing up.",
          html: `<p>There may be an error with the account you are logged into.</p>
          <p>Your login account will either be your email address or an alphanumeric string.</p>
          <p>Please log out of the app once, verify the format of the account assigned to you, and try logging in again.</p>
          <ol>
            <li>Tap the "Settings Icon" in the top right corner of the app.</li>
            <li>Scroll down on the next screen and tap "Log Out."</li>
            <li>Once redirected to the login screen, check for any errors in your login account name and try logging in again.</li>
          </ol>
          <p>Note:</p>
          <ul>
            <li>Be cautious of features like spell check and auto-correction on devices such as iPhones.</li>
            <li>Ensure that full-width and half-width characters are used correctly.</li>
          </ul>
          <p>If the issue persists after following the steps above, please contact the &Well support team.</p>`,
        },
        {
          id: 9004,
          title: "When I type my email address into the app's input form, it says \"Incorrect format.\"",
          html: `<p>Did you enter your email address correctly?</p>
          <p>Many people mistype text, so check for the following two points and try again.</p>
          <ol>
            <li>Are you entering full- or half-width characters (including the "@")?</li>
            <li>Is it being autocorrected? Please try entering letters one at a time to get around the autocorrect function found on iPhones and other smartphones.</li>
          </ol>`,
        },
        {
          id: 9005,
          title: "The app won't open.",
          html: `<p>The app may be frozen. Please follow the steps below to resolve the issue:</p>
          <ol>
            <li>Close the app.<br>
            Note: You can search online for instructions by entering "how to close an app" along with your device type (iPhone or Android).</li>
            <li>Log out of the app and log back in.</li>
            <li>Restart your smartphone.</li>
            <li>Uninstall the app and reinstall it.</li>
          </ol>`,
        },
        {
          id: 9006,
          title: "My steps aren't being reflected properly.",
          html: `<p>It is possible that "the external app is not linked" or "the app is frozen."</p>
          <p>For checking the linkage with external apps, please refer to the following based on your device:</p>
          <ul>
            <li><a href="#a3001">For iPhone (iOS)</a></li>
            <li><a href="#a3002">For Android</a></li>
            <li><a href="#a3003">For Fitbit</a></li>
          </ul>
          <p>If the app is frozen, please follow the steps below to check:</p>
          <p>Example: 1. Close the app → Check if steps are synced.</p>
          <ol>
            <li>Close the app.<br>
            Note: You can search online for instructions by entering "how to close an app" along with your device type (iPhone or Android).</li>
            <li>Log out of the app and log back in.</li>
            <li>Restart your smartphone.</li>
            <li>Uninstall the app and reinstall it.</li>
          </ol>`,
        },
        {
          id: 9007,
          title: "I'm not getting emails from the &well app or Administration.",
          html: `<p>Please confirm the following:</p>

          <ol>
            <li>Have you set restrictions for incoming messages?<br>
            If your registered email address is provided by a cell phone carrier, the following anti-spam measures they use might prevent emails from being delivered correctly. If your address is "Only allowing emails from specified domains to be received" or the "Carrier is providing a strong level of anti-spam protection," please whitelist the [andwell.jp] domain.<br>
            Please check your mobile carrier's website for instructions on how to do so.</li>
            <li>Is your registered email address correct?</li>
            <li>Have they been filtered into the spam or trash folders?<br>
            Some security software and email services may determine them to be spam.<br>
            Please check your "Settings, including automatic mail filtering," and your "Spam folder."</li>
            <li>Is your incoming mailbox full?<br>
            Please check and adjust your mailbox storage limit.</li>
          </ol>`,
        },
        {
          id: 9008,
          title: "I'd like to contact you by phone.",
          html: `<p>Inquiries about &well are handled via a dedicated form.</p>
          <p>We're sorry for the inconvenience, but please contact us with the details of your inquiry using the dedicated form first.</p>
          <p>Note that based on the details of your inquiry, the Administration Office may call you.</p>`,
        },
      ],
    },
  ],
}

export default faqData
